import React, { useLayoutEffect } from 'react';
import { useUser } from 'components/hooks';
import { ErrorScreen } from 'components/common';
import {
  CircularProgress,
  Backdrop
} from '@mui/material';
// import { isExpired, decodeToken } from "react-jwt";


export default function ParamsProvider ({ children }) {
  const { error, initParameters, isLoaded, parameters, user } = useUser();

  useLayoutEffect(() => {
    initParameters({ query: { user: user.username }});
    // eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

  return(
    <div>
      { isLoaded.params ?
        (
          <Backdrop
            invisible
            sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={isLoaded.params}
          >
            <CircularProgress color="primary" />
          </Backdrop>
        )
        : error.params ? (
          <ErrorScreen />
        )
        : parameters && (
          <>{children}</>
        )
      }
    </div>
  );
}
